<template>
  <div>
    <Loading v-show="isLoading"></Loading>
    <div v-if="$data.pageData" :key="$route.query.lang">
    <div class="eight-assistant">
      <Breadcrumbs></Breadcrumbs>
      <div class="container container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h1 class="fontAudit">
              {{ title }}
            </h1>
            <br />
            <div class="page-head-desc" v-html="getSectionNode(0).subTitle"></div>
            <br />
          </div>
          <div class="col-md-6">
            <!-- <img style="width: 100%" src="../images/eightCentre/IT1320x690.jpg" alt="" /> -->
            <img style="width: 100%" :src="getSectionNode(0).imageBaseStr" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="container container-fluid section-padding" v-if="shouldShowSection(1)">
      <h2 class="centres-section-title">
        {{ getSectionNode(1).title }}
      </h2>
      <div v-html="getSectionNode(1).content"></div>
    </div>

    <!-- Manpower by occupation gp ------start -->
    <div class="occupation-assistant" v-if="shouldShowSection(2)">
      <div class="container container-fluid section-padding">
        <div class="occupation-group">
          <h2 class="centres-section-title">
            {{ getSectionNode(2).title }}
          </h2>
          <div v-html="getSectionNode(2).content"></div>
        </div>
      </div>
    </div>

    <!--Key Factors Impacting Outlook ---- start-->
    <div class="container container-fluid section-padding" v-if="shouldShowSection(3)">
      <h2 class="centres-section-title">
        {{ $t("centresLabel.factor") }}
      </h2>
      <div class="factor-grid" v-html="getSectionNode(3).content"></div>
    </div>

    <!--Occupation in demand ---- start-->
    <div class="occupation-assistant">
      <div class="container container-fluid section-padding" v-if="$data.occupSec">
        <h2 class="centres-section-title">
          {{ $t("eightCentres.occupationsInDemand") }}
        </h2>
        <div class="section-four" v-if="$data.occupSec.length">
          <!-- button ----->
          <div class="section-four__demand-content" v-if="$data.occupSec.length > 1">
            <button v-for="(row, index) in $data.occupSec" :key="row.id || index" class="SemiBold" @click="$data.activeOccupSec = getDemandSetKey(row, index)" :class="{ 'tab-active': $data.activeOccupSec === getDemandSetKey(row, index) }">
              {{ getDemandSetLabel(row, index) }}
            </button>
          </div>

          <div v-for="(row, index) in $data.occupSec" :key="`demand-${row.id || index}`" v-if="$data.activeOccupSec === getDemandSetKey(row, index)">
            <div class="factor-grid" v-html="row.content || ''"></div>
          </div>

          <!------end button------>
        </div>
      </div>
    </div>
    <!--section four end -->
    <!-- Essential skills and knowledge ---- start-->
    <div class="container container-fluid" v-if="shouldShowSection(5) || shouldShowSection(6)">
      <div class="section-five" id="linksMap">
        <h2 class="centres-section-title">
          {{ $t("eightCentres.essentialSkillsKnowledge") }}
        </h2>
        <div class="section-five__skills-content">
          <button v-if="shouldShowSection(5)" class="SemiBold" @click="activeLinksTab = 'skills'" :class="{ 'tab2-active': activeLinksTab === 'skills' }">
            {{ $t("eightCentres.skills") }}
          </button>
          <button v-if="shouldShowSection(6)" class="SemiBold" @click="activeLinksTab = 'knowledge'" :class="{ 'tab2-active': activeLinksTab === 'knowledge' }">
            {{ $t("eightCentres.knowledge") }}
          </button>
        </div>

        <div v-if="activeLinksTab === 'skills' && shouldShowSection(5)" class="section-five__skills-button" v-html="getSectionNode(5).content"></div>
        <div v-if="activeLinksTab === 'knowledge' && shouldShowSection(6)" class="section-five__skills-button" v-html="getSectionNode(6).content"></div>
      </div>
    </div>

    <!-- Remarks ---- start-->
    <div class="container container-fluid section-padding" v-if="shouldShowSection(10)">
      <div v-html="getSectionNode(10).content"></div>
    </div>
    <!-- Remarks ---- end-->
    </div>
  </div>
</template>

<script>
import "../style/pages.css";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    Loading,
  },
  data() {
    const routeLanguage = this.$route.query.lang;
    const storeLanguage = this.$store.state.language;
    const language = routeLanguage || storeLanguage || "en_US";
    const languagePrefixMap = {
      en_US: "EN-",
      zh_HK: "TC-",
      zh_CN: "SC-",
    };
    return {
      changeDex: 0,
      langQ: languagePrefixMap[language] || "EN",
      metaUrl: `/mip_api/eightMajor/searchCentre?id=${this.$route.params.id}`,
      dataUrl: `/mip_api/eightMajor/searchDetail?refId=${this.$route.params.id}&lang=${this.language}`,
      language,
      title: null,
      pageData: null,
      occupSec: null,
      activeLinksTab: "skills",
      activeOccupSec: "",
      isLoading: false,
    };
  },
  async mounted() {
    await this.reloadPageData();
  },
  watch: {
    "$route.query.lang": function () {
      this.reloadPageData();
    },
    "$route.params.id": function () {
      this.metaUrl = `/mip_api/eightMajor/searchCentre?id=${this.$route.params.id}`;
      this.dataUrl = `/mip_api/eightMajor/searchDetail?refId=${this.$route.params.id}&lang=${this.language}`;
      this.reloadPageData();
    },
    title: function(newTitle) {
      document.title = newTitle;
    }
  },
  beforeDestroy() {
    if (this._pageLoadAbort) {
      this._pageLoadAbort.abort();
    }
  },
  methods: {
    getLanguageFromRoute() {
      const language = this.$route.query.lang || this.$store.state.language;
      if (language === "zh_HK" || language === "zh_CN" || language === "en_US") {
        return language;
      }
      return "en_US";
    },
    setLanguageContext() {
      this.language = this.getLanguageFromRoute();
      const languagePrefixMap = {
        en_US: "EN",
        zh_HK: "TC",
        zh_CN: "SC",
      };
      this.langQ = languagePrefixMap[this.language] || "EN";
       this.metaUrl = `/mip_api/eightMajor/searchCentre?id=${this.$route.params.id}`;
  this.dataUrl = `/mip_api/eightMajor/searchDetail?refId=${this.$route.params.id}&lang=${this.language}`;
    },
    // async loadDetailContent(signal) {
    //   const response = await fetch(this.$data.dataUrl, { signal });
    //   if (!response.ok) {
    //     throw new Error(`Fetch failed with status: ${response.status}`);
    //   }
    //   const { result } = await response.json();
    //   const resultList = Array.isArray(result) ? result : [];
    //   this.pageData = resultList.filter(
    //     ({ type }) => type.indexOf(this.$data.langQ) == 0
    //   );
    //   this.occupSec = this.pageData.filter(
    //     ({ type, isDeleted }) => type == `${this.$data.langQ}4` && Number(isDeleted) !== 1
    //   );
    //   this.ensureActiveLinksTab();
    //   if (this.occupSec.length) {
    //     this.activeOccupSec = this.getDemandSetKey(this.occupSec[0], 0);
    //   } else {
    //     this.activeOccupSec = "";
    //   }
    // },
    async loadDetailContent(signal) {
  const response = await fetch(this.dataUrl, { signal });
  if (!response.ok) {
    throw new Error(`Fetch failed with status: ${response.status}`);
  }
  const { result } = await response.json();
  const resultList = Array.isArray(result) ? result : [];

  // Since Backend already filters records by language (prefix 'EN', 'TC', or 'SC'),
  // pageData can take the returned result directly:
  this.pageData = resultList;

  // Match the type format stored in DB (e.g. "TC4" or "TC-4")
  this.occupSec = this.pageData.filter(
    ({ type, isDeleted }) => (type === `${this.langQ}4` || type === `${this.langQ}-4`) && Number(isDeleted) !== 1
  );

  this.ensureActiveLinksTab();
  if (this.occupSec.length) {
    this.activeOccupSec = this.getDemandSetKey(this.occupSec[0], 0);
  } else {
    this.activeOccupSec = "";
  }
}
,
    async loadMetaContent() {
      const response = await fetch(this.$data.metaUrl);
      if (!response.ok) {
        throw new Error(`Fetch failed with status: ${response.status}`);
      }
      const metaResult = await response.json();
      const metaRow = Array.isArray(metaResult.result) ? metaResult.result[0] : null;
      const titleMap = {
        en_US: "titleEn",
        zh_HK: "titleTc",
        zh_CN: "titleSc",
      };
      this.$data.title = metaRow ? metaRow[titleMap[this.language]] : "";
    },
    async reloadPageData() {
      if (this._pageLoadAbort) {
        this._pageLoadAbort.abort();
      }
      const controller = new AbortController();
      this._pageLoadAbort = controller;
      const { signal } = controller;
      this.setLanguageContext();
      this.pageData = null;
      this.occupSec = null;
      this.title = "";
      this.isLoading = true;
      try {
        await this.loadDetailContent(signal);
        await this.loadMetaContent(signal);
      } catch (error) {
        if (error && error.name === "AbortError") return;
        // Keep the page renderable even if an API call fails.
        if (!Array.isArray(this.pageData)) this.pageData = [];
        if (!Array.isArray(this.occupSec)) this.occupSec = [];
        if (!this.title) this.title = "";
      } finally {
        // Only clear loading if this is still the latest request;
        // a superseded (aborted) call must not hide the newer one's spinner.
        if (this._pageLoadAbort === controller) {
          this.isLoading = false;
        }
      }
    },
    getDemandSetKey(row, index) {
      if (row && (row.id || row.id === 0)) return `id-${row.id}`;
      return `idx-${index}`;
    },
    getDemandSetLabel(row, index) {
      if (row && row.title && row.title.trim()) return row.title;
      return `Set ${index + 1}`;
    },
    getSectionNode(typeIndex) {
      const self = this;
      const emptySection = {
        title: "",
        subTitle: "",
        content: "",
      };
      if (!Array.isArray(self.pageData) || !self.pageData.length) return emptySection;

      const foundRow = self.pageData.find(
        ({ type }) => type == self.$data.langQ + typeIndex || type === `${self.langQ}-${typeIndex}`
      );
      if (!foundRow) return emptySection;

      const sectionNode = {
        ...emptySection,
        ...foundRow,
      };

      switch(typeIndex){
        case 5:
        case 6: {
          if (!sectionNode.content) return sectionNode;
          const $html = document.createElement("DIV");
          $html.innerHTML = sectionNode.content;
          $html.querySelectorAll(".diamond-icon").forEach(($row)=>{
            const $removeBtn = $row.querySelector(".link-remove-btn");
            if ($removeBtn) $removeBtn.remove();

            const $oldLink = $row.querySelector(".occupation_link");
            const $itemUrl = $row.querySelector(".item-url");
            if (!$oldLink || !$itemUrl || !$itemUrl.innerText) return;

            const $a = document.createElement("a");
            $a.className = "occupation_link";
            $a.innerText = $oldLink.innerText || "";
            $a.href = $itemUrl.innerText;
            $oldLink.remove();
            $row.appendChild($a);
          });
          sectionNode.content = $html.innerHTML;
        }
        break;
        default:
      }

      return sectionNode;
    },
    shouldShowSection(typeIndex) {
      const row = this.getSectionNode(typeIndex);
      if (!row || !row.type|| !row.content) return false;
      return Number(row.isDeleted) !== 1;
    },
    ensureActiveLinksTab() {
      if (this.shouldShowSection(5)) {
        if (this.activeLinksTab !== "skills" && !this.shouldShowSection(6)) {
          this.activeLinksTab = "skills";
        }
        return;
      }
      if (this.shouldShowSection(6)) {
        this.activeLinksTab = "knowledge";
      }
    },
  },
};
</script>
